import { InterSvgIcon } from 'components'
import { useManageNotificationsProductNavTic } from 'pages/manage-notifications/hooks/useManageNotificationsProductNavTic'
import {
  ProductContainer,
  ProductIconAndNameContainer,
  ProductPageLink,
} from 'pages/manage-notifications/styles/ManageNotifications.styles'
import { TProduct } from 'pages/manage-notifications/types/ManageNotifications.types'

import { Text } from '@interco/inter-ui/components/Text'

function ProductCard({
  product,
  productKey,
  isBrazil,
}: {
  productKey: string
  product: TProduct
  isBrazil: boolean
}) {
  const onProductNav = useManageNotificationsProductNavTic(productKey)

  return (
    <ProductPageLink key={productKey} to={productKey} onClick={onProductNav}>
      <ProductContainer>
        <ProductIconAndNameContainer>
          {product.icon && (
            <InterSvgIcon
              width={20}
              height={20}
              iconRef={product.icon}
              color="var(--typography500)"
            />
          )}
          {isBrazil && (
            <Text variant="body-3" color="typography" colorWeight={500}>
              {product.name}
            </Text>
          )}
          {!isBrazil && (
            <Text variant="headline-h3" color="typography" colorWeight={500} semiBold="true">
              {product.name}
            </Text>
          )}
        </ProductIconAndNameContainer>
        {product.details && (
          <Text variant="caption-1" color="typography" colorWeight={400}>
            {product.details}
          </Text>
        )}
      </ProductContainer>
      <InterSvgIcon
        width={24}
        height={24}
        iconRef="core/action-navigation/ic_chevron_right"
        color="var(--secondary500)"
      />
    </ProductPageLink>
  )
}

export { ProductCard }
